import { isMobile } from '@elfsight/widget-utils';
import type {
  ChatsChannelBase,
  ChatsChannelSetting
} from '../../../constants/types';
import { ChatsChannelType } from '../../../constants/types';
import { getChatIcon } from '../../helpers';

export const getFacebookSettings = ({
  facebookPage
}: Partial<ChatsChannelBase>) => {
  if (!facebookPage) return null;

  // const page = facebookPage?.page || facebookPage; old version
  // const dataLink = page?.data?.link || page?.link; old version
  // const parsedLink =
  //   page?.value ||
  //   dataLink?.replace('https://www.facebook.com/', '')?.replace('/', '');

  const dataLink = facebookPage?.data?.link;
  const parsedLink = dataLink
    ?.replace('https://www.facebook.com/', '')
    ?.replace('/', '');

  const url = isMobile()
    ? `https://m.me/${parsedLink}`
    : `https://facebook.com/msg/${parsedLink}`;

  return {
    provider: ChatsChannelType.facebook,
    link: { url },
    title: 'Messenger',
    icon: getChatIcon(ChatsChannelType.facebook),
    color: 'rgb(0, 132, 255)'
  } as ChatsChannelSetting;
};
